module.exports = __webpack_public_path__ + "img/title-bg.6180bab9.png";